// extracted by mini-css-extract-plugin
module.exports = {"Content":"Content--EClT0","twitterWidgetContainer":"twitterWidgetContainer--rzvch"};